"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var graph_exports = {};
__export(graph_exports, {
  WorkspaceGraph: () => WorkspaceGraph
});
module.exports = __toCommonJS(graph_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_memoize = require("./memoize.js");
class WorkspaceGraph {
  constructor(props) {
    this.allWorkspaces = () => {
      return [...this.workspaces];
    };
    this.allProjects = () => {
      return [...this.projects];
    };
    this.allTeams = () => {
      return [...this.teams];
    };
    this.optFindWorkspaceById = (0, import_memoize.memoize1)((id) => {
      return this.workspaces.find((ws) => ws.id === id) ?? null;
    });
    this.findWorkspaceById = (id) => {
      return this.optFindWorkspaceById(id) ?? (0, import_util.raise)(new Error(`Workspace not found: ${id}`));
    };
    this.optFindProjectById = (0, import_memoize.memoize1)((id) => {
      return this.projects.find((p) => p.id === id) ?? null;
    });
    this.findProjectById = (id) => {
      return this.optFindProjectById(id) ?? (0, import_util.raise)(new Error("Project not found"));
    };
    this.optFindTeamById = (0, import_memoize.memoize1)((id) => {
      return this.teams.find((t) => t.id === id) ?? null;
    });
    this.findTeamById = (id) => {
      return this.optFindTeamById(id) ?? (0, import_util.raise)(new Error("Team not found"));
    };
    this.optFindWorkspaceByProjectId = (0, import_memoize.memoize1)((id) => {
      const p = this.optFindProjectById(id);
      return p == null ? null : this.optFindWorkspaceById(p.workspaceId);
    });
    this.findWorkspaceByProjectId = (id) => {
      return this.optFindWorkspaceByProjectId(id) ?? (0, import_util.raise)(new Error(`Workspace not found for project: ${id}`));
    };
    this.optFindWorkspaceByTeamId = (0, import_memoize.memoize1)((id) => {
      const t = this.optFindTeamById(id);
      return t == null ? null : this.optFindWorkspaceById(t.workspaceId);
    });
    this.findWorkspaceByTeamId = (id) => {
      return this.optFindWorkspaceByTeamId(id) ?? (0, import_util.raise)(new Error(`Workspace not found for team: ${id}`));
    };
    this.findProjectsByWorkspaceId = (0, import_memoize.memoize1)((id) => {
      return this.projects.filter((p) => p.workspaceId === id);
    });
    this.findProjectsByTeamId = (0, import_memoize.memoize1)((id) => {
      const t = this.optFindTeamById(id);
      return t == null ? [] : (0, import_util.filterAndMap)(t.projectIds, this.optFindProjectById);
    });
    this.findTeamsByWorkspaceId = (0, import_memoize.memoize1)((id) => {
      return this.teams.filter((t) => t.workspaceId === id);
    });
    this.findTeamsByProjectId = (0, import_memoize.memoize1)((id) => {
      return this.teams.filter((t) => t.projectIds.includes(id));
    });
    this.optFindWorkspaceByRef = (0, import_memoize.memoize1)((ref) => {
      return this.workspaces.find((ws) => ws.id === ref || ws.alias === ref) ?? null;
    });
    this.findWorkspaceByRef = (ref) => {
      return this.optFindWorkspaceByRef(ref) ?? (0, import_util.raise)(new Error(`Workspace not found: ${ref}`));
    };
    this.optFindProjectByRef = (0, import_memoize.memoize2)((pref, wref) => {
      const p = (0, import_types.isProjectId)(pref) ? this.optFindProjectById(pref) : null;
      if (p != null) {
        return p;
      } else {
        const ws = wref == null ? null : this.optFindWorkspaceByRef(wref);
        return ws == null ? null : this.findProjectsByWorkspaceId(ws.id).find((p2) => p2.alias === pref) ?? null;
      }
    });
    this.findProjectByRef = (pref, wref) => {
      return this.optFindProjectByRef(pref, wref) ?? (0, import_util.raise)(new Error("Project not found"));
    };
    this.optFindTeamByRef = (0, import_memoize.memoize2)((tref, wref) => {
      const t = (0, import_types.isTeamId)(tref) ? this.optFindTeamById(tref) : null;
      if (t != null) {
        return t;
      } else {
        const ws = wref == null ? null : this.optFindWorkspaceByRef(wref);
        return ws == null ? null : this.findTeamsByWorkspaceId(ws.id).find((t2) => t2.id === tref || t2.alias === tref) ?? null;
      }
    });
    this.findTeamByRef = (tref, wref) => {
      return this.optFindTeamByRef(tref, wref) ?? (0, import_util.raise)(new Error("Team not found"));
    };
    this.findProjectsByWorkspaceRef = (0, import_memoize.memoize1)((wref) => {
      const ws = this.optFindWorkspaceByRef(wref);
      return ws == null ? [] : this.projects.filter((t) => t.workspaceId === ws.id);
    });
    this.findProjectsByTeamRef = (0, import_memoize.memoize2)((tref, wref) => {
      const t = this.optFindTeamByRef(tref, wref);
      return t == null ? [] : this.projects.filter((p) => p.teamIds.includes(t.id));
    });
    this.findTeamsByWorkspaceRef = (0, import_memoize.memoize1)((wref) => {
      const ws = this.optFindWorkspaceByRef(wref);
      return ws == null ? [] : this.teams.filter((t) => t.workspaceId === ws.id);
    });
    this.findTeamsByProjectRef = (0, import_memoize.memoize2)((pref, wref) => {
      const p = this.optFindProjectByRef(pref, wref);
      return p == null ? [] : this.teams.filter((t) => t.projectIds.includes(p.id));
    });
    this.stringify = () => {
      const ans = [];
      for (const ws of this.workspaces) {
        ans.push(`- workspace ${ws.id} / ${ws.alias}`);
        for (const p of this.findProjectsByWorkspaceId(ws.id)) {
          ans.push(`  - project ${p.id} / ${p.alias}`);
          for (const t of this.findTeamsByProjectId(p.id)) {
            ans.push(`    - team ${t.id} / ${t.alias}`);
          }
        }
      }
      return ans.join("\n");
    };
    this.workspaces = (0, import_lodash.sortBy)(arrayify(props.workspaces), (ws) => ws.alias);
    this.projects = (0, import_lodash.sortBy)(props.projects, (p) => p.alias);
    this.teams = (0, import_lodash.sortBy)(props.teams, (t) => t.alias);
  }
}
function arrayify(value) {
  return Array.isArray(value) ? value : [value];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WorkspaceGraph
});
//# sourceMappingURL=graph.js.map
